<template>
  <div class="page">
    <div class="container block-primary">
      <h1 class="header-title">นโยบายความเป็นส่วนตัว</h1>
      <h2 class="page-title">รายละเอียด</h2>



    </div>
  </div>
</template>

<script>

export default {
  name: 'privacy'
}
</script>



// WEBPACK FOOTER //
// Privacy.vue?4934784e